export default __webpack_public_path__ + "static/media/Landing1.4f21d350.png";